import React from "react";
import { ObjectListValues, SortableListValues } from "../";

export const ObjectListNumbers = (props) => <ObjectListValues {...props} editText="Editar valor" addText="Agregar valor" SortableList={SortableListValues} />